export default __webpack_public_path__ + "static/media/moi.1ec0d3ce.png";